import { Injectable } from '@angular/core';
import { ApiBaseService } from './api.base.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, of } from 'rxjs';
import { userDataService } from './userDataService';

@Injectable({
  providedIn: 'root',
})
export class userServices extends ApiBaseService {
  constructor(public http: HttpClient,private userDataService:userDataService) {
    super(http, '/users');
  }

  checkEmailExists(email: string, userId?: string): Observable<any> {
    const params = { email };
    const id = userId ? userId : null;
    return this.http.get(`${environment.apiUrl}/users/email/${id}`, {
      params,
    });
  }

  saveSignature(body){
    return this.http.post(`${environment.apiUrl}/users/saveSignature`, body);
  }

  saveToken(token: string, userId?: string): Observable<any> {
    const storedToken = localStorage.getItem('fcmToken');
    if (storedToken === token) {
        return of(null);
    }
    localStorage.setItem('fcmToken', token);
    const body = { fcmToken: token, id: userId };
    return this.http.post(`${environment.apiUrl}/users/saveFCM`, body);
  }

  useresExceptMe(lead_id){
    return this.http.get(`${environment.apiUrl}/users/followers/${lead_id}`);
  }

  getPreferences(id){
    return this.http.get(`${environment.apiUrl}/users/preferences/${id}`);
  }

  updateUserFollowers(data){
    return this.http.put(`${environment.apiUrl}/users/followers`,data);
  }

  updateUserPreferences(data,id){
    return this.http.put(`${environment.apiUrl}/users/preferences/${id}`,data);
  }

  removeUserFollowers(id){
    return this.http.delete(`${environment.apiUrl}/users/followers/${id}`);
  }

  uploadPhoto(id, formData) {
    return this.http.put(`${environment.apiUrl}/users/upload_photo/${id}`, formData);
  }

  removePhoto(id: number) {
    return this.http.delete(`${environment.apiUrl}/users/remove_photo/${id}`);
  }

  // NEW: Update user's preferred view mode
  updateViewMode(userId: number, viewMode: 'modal' | 'fullscreen'): Observable<any> {
    const body = { preferred_view_mode: viewMode };
    return this.http.put(`${environment.apiUrl}/users/view-mode/${userId}`, body);
  }

  // NEW: Get current user's view mode from userData
  getCurrentViewMode(): 'modal' | 'fullscreen' {
    const userData = localStorage.getItem('userData');
    if (userData) {
      const user = JSON.parse(userData);
      return user.preferred_view_mode || 'fullscreen'; // Default to fullscreen as per your preference
    }
    return 'fullscreen';
  }

  // NEW: Update view mode and sync with localStorage
  setViewMode(viewMode: 'modal' | 'fullscreen'): Observable<any> {
    const userData = localStorage.getItem('userData');
    if (userData) {
      const user = JSON.parse(userData);

      // Update view mode
      user.preferred_view_mode = viewMode;

      // Update localStorage immediately for responsiveness
      localStorage.setItem('userData', JSON.stringify(user));

      // Update the userDataService signal to refresh cached data
      this.userDataService.setUserData(user);

      // Update database
      return this.updateViewMode(user.id, viewMode);
    }
    return of(null);
  }
}